import { AuthError, type AuthSession } from '@emazy/shared-types';

import { mapCognitoUser } from './cognitoUserMapper';
import type { CognitoSessionLike, CognitoUserLike } from './types';

export function mapCognitoSession(user: CognitoUserLike, session: CognitoSessionLike): AuthSession {
  const expiration = session.tokens?.accessToken.payload.exp;
  if (typeof expiration !== 'number' || !Number.isFinite(expiration)) {
    throw new AuthError({
      code: 'session-expired',
      message: 'Cognito session has no valid expiry.',
    });
  }
  return {
    user: mapCognitoUser(user, session),
    expiresAt: new Date(expiration * 1000).toISOString(),
  };
}
